import type { ComponentType, ElementType } from 'react'

import type { InputLabelProps } from '@material-ui/core/InputLabel'
import {
  type DisplayProps,
  type PaletteProps,
  type SpacingProps,
} from '@material-ui/system'

import { InputLabelStyled } from './styles/InputLabelStyled'

export interface IInputLabelProps
  extends
    Omit<InputLabelProps, 'color' | 'margin'>,
    SpacingProps,
    DisplayProps,
    PaletteProps {
  /**
   * The element that carries the label styles. Defaults to `label`. Pass a
   * non-label element (e.g. `'div'`) to style a label row whose `<label>`
   * sits inside it beside controls that must not join the label, such as a
   * focusable tooltip trigger.
   */
  component?: ElementType
}

// Styled Material InputLabel
export const InputLabel: ComponentType<IInputLabelProps> = (props) => (
  <InputLabelStyled {...props} />
)
InputLabel.defaultProps = {
  mb: 0.25,
}

InputLabel.displayName = 'InputLabel'

export { type InputLabelProps, InputLabelStyled }
